import styled from 'styled-components';

export const PageTitle = styled.h1`
  text-align: center;
`;

export const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: ${p => p.theme.space[4]}px;
`;

// export const Text = styled.p`
//   text-align: center;
// `;